import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { DASHBOARD_ACTIONS, DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import BonusMoneyLambda from './BonusMoneyLambda';

const BonusMoneyLambdaDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				exact
				component={BonusMoneyLambda}
				path={path}
				configPageName={PAGE_NAMES.dashboard}
				configActionName={DASHBOARD_ACTIONS.LIST_BONUS_MONEY_LAMBDA_REQUEST}
				configResourceName={DASHBOARD_RESOURCES.bonusMoneyLambda}
			/>
			<Redirect to={path} />
		</Switch>
	);
};

export default BonusMoneyLambdaDashboard;
